import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Marketing from "../../../assets/img/SolutionsIcons/AgilysysDigitalMarketing.svg";
import { Header } from "../../../components/Header";

const MarketingFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash marketingPage">
            <div className="page-title"><img src={Marketing} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A flexible hospitality marketing automation solution
supporting targeted guest email and SMS marketing
communications with event and campaign-based rules.{'\n\n'}
                </div>
                <div className="std-text">
                Marketers can segment guests by type or other criteria and
send context-related communications at time of reservation,
check-in, check-out or by marketing campaign types. Digital
email campaigns allow users an inexpensive way to stay
connected to their guest throughout the guest journey.{'\n\n'}
                </div>
                <div className="std-text">
                The result is increased return visits and improved revenue
                from offers based upon guest segment and journey stage.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Digital Marketing", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/marketing1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/marketing2.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveMarketing.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default MarketingFPage;